import { SvgIcon } from "@material-ui/core";

export const Stop = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <ellipse stroke="currentColor" fill="none" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" cx="12" cy="12" rx="10" ry="10"/>
    <rect x="9" y="9" width="6" height="6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round"/>
  </SvgIcon>
);
